/**
 * "Install ZIvapp" prompt.
 *
 * Chrome on Android fires beforeinstallprompt when the PWA criteria are met
 * (HTTPS, manifest, service worker, icons). The event must be captured and
 * replayed later from a user gesture, which is what this does.
 *
 * iOS Safari never fires it — there the user installs via Share > Add to Home
 * Screen, so the UI needs to explain that instead. isIOS() identifies that case.
 */

let deferredPrompt = null

window.addEventListener('beforeinstallprompt', event => {
  // Stop Chrome showing its own mini-infobar; we decide when to ask.
  event.preventDefault()
  deferredPrompt = event
  window.dispatchEvent(new CustomEvent('ziv:install-available'))
})

window.addEventListener('appinstalled', () => {
  deferredPrompt = null
  window.dispatchEvent(new CustomEvent('ziv:installed'))
})

export function canInstall() {
  return deferredPrompt !== null
}

/** Must be called from a click or tap, or the browser ignores it. */
export async function promptInstall() {
  if (!deferredPrompt) return 'unavailable'
  deferredPrompt.prompt()
  const { outcome } = await deferredPrompt.userChoice
  deferredPrompt = null
  return outcome
}

export function isStandalone() {
  return window.matchMedia('(display-mode: standalone)').matches
    || window.navigator.standalone === true
}

export function isIOS() {
  return /iphone|ipad|ipod/i.test(navigator.userAgent)
}
